import './index.less'

export default class PhotovolaticForHome {
  constructor({ el, }) {
    this.targetDOM = document.querySelector(el)
    this.el = el
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
    const isAnimation = document.querySelector('.collection-animation').getAttribute("data-animation")
    if (clientWidth >= 1024 && isAnimation === 'true') {
      if(pageInfo.template.indexOf("product") !== -1) return
      (window.gsap && this.targetDOM) && this.init()
    }
  }
  init() {
    window.gsap.registerPlugin(window?.ScrollTrigger);
    const target = document.querySelector('img.balcony-scale-img')

    window.gsap.to(`${this.el} img.balcony-scale-img`, {
      scale: () => window.innerWidth / target.offsetWidth,
      x: 0,
      y: 0,
      scrollTrigger: {
        trigger: this.el,
        start: "top top", // 当 phone-wrap 元素底部，滚动到可视区域底部时, 开始动画
        end: () => "+=500", // will be updated , 当 phone-wrap 底部，到达可视区域顶部的时候，结束动画
        scrub: 1, // 表示动画可以重复执行改成false表示只执行一次
        pin: true, // 动画执行期间，页面不进行滚动，动画执行结束后
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          if (self.progress === 1) {
            target.classList.remove('rounded-24', 'lg:j-rounded-12', 'xl:a-rounded-12')
          } else {
            target.classList.add('rounded-24', 'lg:j-rounded-12', 'xl:a-rounded-12')
          }
        }
      },
    });
  }
}
